import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectUser } from '../../redux/slices/authSlice';
import { setSelectedTab, selectSelectedTab } from '../../redux/slices/lawyerDashboardSlice';
import {
  DashboardHeader,
  TabNavigation,
  ProfileCard,
  PointsDisplay,
  MetricCard,
} from '../../components/Dashboard';

const LawyerDashboard = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const selectedTab = useSelector(selectSelectedTab);
  const [showNotifications] = useState(false);
  const [pointsActiveTab, setPointsActiveTab] = useState('puntos');

  // Función para obtener el nombre del usuario (solo primer nombre)
  const getUserName = () => {
    if (user?.first_name) return user.first_name;
    if (user?.name) {
      // Si user.name contiene nombre completo, extraer solo el primer nombre
      return user.name.split(' ')[0];
    }
    return 'Usuario';
  };

  // Función para cambiar de tab
  const handleTabChange = tab => {
    dispatch(setSelectedTab(tab));
  };

  useEffect(() => {
    // Aquí puedes cargar datos específicos del abogado
    if (user) {
      console.log('Dashboard cargado para abogado:', user.name);
      // Asegurar que esté en la tab 'inicio' por defecto
      if (!selectedTab || selectedTab === 'overview') {
        dispatch(setSelectedTab('inicio'));
      }
      // TODO: Cargar datos del dashboard (citas, consultas, estadísticas)
    }
  }, [user, dispatch, selectedTab]);

  // Datos mock basados en el diseño
  const mockData = {
    stats: {
      totalCitas: 7265,
      proximasCitas: 7265,
      reclamaciones: 7265,
    },
    puntos: 3599,
    casosCompletados: 25,
    clicks: 7265,
    vistasAlPerfil: 7265,
    tiempoPromedio: 25,
    fechaMiembro: '30 de Junio 2025',
  };

  // Función para renderizar contenido de diferentes tabs (para futuras implementaciones)
  const renderTabContent = () => {
    switch (selectedTab) {
      case 'inicio':
        return null; // El contenido principal ya se muestra en el render principal
      case 'encuentraAbogado':
        return (
          <div className="bg-white rounded-lg shadow-sm p-6">
            <h3 className="text-lg font-medium text-gray-900 mb-4">Encuentra un Abogado</h3>
            <p className="text-gray-600">
              Aquí podrás buscar otros profesionales para referencias o colaboraciones.
            </p>
          </div>
        );
      case 'consultaExpress':
        return (
          <div className="bg-white rounded-lg shadow-sm p-6">
            <h3 className="text-lg font-medium text-gray-900 mb-4">Consulta Express</h3>
            <p className="text-gray-600">Responde a las consultas de clientes potenciales.</p>
          </div>
        );
      case 'estadisticas':
        return (
          <div className="bg-white rounded-lg shadow-sm p-6">
            <h3 className="text-lg font-medium text-gray-900 mb-4">Estadísticas de Citas</h3>
            <p className="text-gray-600">
              Visualiza datos estadísticos sobre tus citas y rendimiento.
            </p>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen">
      {/* Header principal */}
      <DashboardHeader userName={getUserName()} />

      {/* Navegación por tabs */}
      <TabNavigation selectedTab={selectedTab} onTabChange={handleTabChange} />

      {/* Contenido Principal */}
      <main className="px-1 py-4 space-y-4">
        {/* Profile Card with integrated stats */}
        <ProfileCard user={user} notificationCount={4} stats={mockData.stats} />

        {/* Points Display */}
        <PointsDisplay
          points={mockData.puntos}
          casosCompletados={mockData.casosCompletados}
          casosParaSiguienteNivel={30}
          activeTab={pointsActiveTab}
          onTabChange={setPointsActiveTab}
        />

        {/* Metrics Cards */}
        <div className="space-y-4 mx-auto px-4">
          {/* First Row: Clicks and Vistas al Perfil side by side */}
          <div className="grid grid-cols-2 gap-4">
            <MetricCard title="Clicks" value={mockData.clicks} percentageChange={11.01} />
            <MetricCard
              title="Vistas al Perfil"
              value={mockData.vistasAlPerfil}
              percentageChange={11.01}
            />
          </div>

          {/* Second Row: Tiempo Promedio full width */}
          <MetricCard
            title="Tiempo Promedio del Usuario en Perfil"
            value={mockData.tiempoPromedio}
            percentageChange={11.01}
            unit="min"
          />

          {/* Member Since */}
          <div className="text-center text-sm text-gray-500 pt-2">
            Miembro desde: {mockData.fechaMiembro}
          </div>
        </div>
      </main>
    </div>
  );
};

export default LawyerDashboard;
